import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../lib/cn";
/** The raised container. Everything else in this file is a slot of it. */
export const Card = forwardRef(function Card({ className, ...props }, ref) {
    return (_jsx("div", { ref: ref, className: cn("bg-surface-raised text-primary border border-border rounded-card shadow-card", className), ...props }));
});
Card.displayName = "Card";
export const CardHeader = forwardRef(function CardHeader({ className, ...props }, ref) {
    return (_jsx("div", { ref: ref, className: cn("flex flex-col gap-1 p-6 pb-4", className), ...props }));
});
CardHeader.displayName = "CardHeader";
export const CardTitle = forwardRef(function CardTitle({ className, as: Component = "h2", ...props }, ref) {
    return (_jsx(Component, { ref: ref, className: cn("text-xl font-semibold text-primary", className), ...props }));
});
CardTitle.displayName = "CardTitle";
export const CardDescription = forwardRef(function CardDescription({ className, ...props }, ref) {
    return (_jsx("p", { ref: ref, className: cn("text-sm text-subtle", className), ...props }));
});
CardDescription.displayName = "CardDescription";
export const CardContent = forwardRef(function CardContent({ className, ...props }, ref) {
    return _jsx("div", { ref: ref, className: cn("p-6 pt-0", className), ...props });
});
CardContent.displayName = "CardContent";
export const CardFooter = forwardRef(function CardFooter({ className, ...props }, ref) {
    return (_jsx("div", { ref: ref, className: cn("flex flex-wrap items-center gap-3 p-6 pt-0", className), ...props }));
});
CardFooter.displayName = "CardFooter";
//# sourceMappingURL=card.js.map